import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'parentMeta'
})
export class ParentMetaPipe implements PipeTransform {
	transform(value: string): any {
		let multiplier = {};
		if (value) {
			multiplier = JSON.parse(value);
		}
		return multiplier['comment'];
	}
}
